import TerminalTap from './taps/terminal'

import { useState } from 'react'
import { TapType } from '../footer'

import './footerTaps.scss'

export type InputListItem = { text: string | JSX.Element, disabledPs?: boolean }

type FooterTapsPorps = {
  activTab: TapType
}

function FooterTaps(props: Readonly<FooterTapsPorps>) {
  const [inputList, setInputList] = useState<Array<InputListItem>>([])
  const nowFullYear = new Date().getFullYear()

  if (props.activTab === 'terminal') {
    return (
      <TerminalTap inputList={inputList} setInputList={setInputList} />
    )
  } else if (props.activTab === 'console') {
    return (
      <div>
        console
      </div>
    )
  }

  return (
    <div className='comp-copy'>
      <div className='copy-text'>Copyright © {nowFullYear} by dwain - All Rights Reserved</div>
    </div>
  )
}

export default FooterTaps
